// API响应统一格式
export interface ApiResponse<T = unknown> {
	code: number; // 0表示成功，其他表示错误
	message: string;
	data: T;
}

export interface ApiError {
	code: number;
	message: string;
	details?: unknown;
	requestId?: string;
}

// 错误码定义（与后端保持一致）
export const ErrorCode = {
	SUCCESS: 0,
	// 通用错误 (100000-100999)
	INTERNAL_SERVER_ERROR: 100000,
	INVALID_PARAMS: 100001,
	UNAUTHORIZED: 100002,
	FORBIDDEN: 100003,
	NOT_FOUND: 100004,
	METHOD_NOT_ALLOWED: 100005,
	RATE_LIMITED: 100006,
	// 网络错误
	NETWORK_ERROR: -1,
} as const;

export interface PaginationParams {
	page: number;
	pageSize: number;
}

export interface PaginationResponse<T> {
	list: T[];
	total: number;
	page: number;
	pageSize: number;
	totalPages: number;
}
